import { UserPermissions } from "Infrastructure/Api/permissions";
import { PermissionGuard } from "Infrastructure/Components/PermissionGuard";
import { GeneralSetupEditPage } from "Settings/Modules/GeneralSetup/Pages/GeneralSetupEdit";
import { OrderSetupEditPage } from "Settings/Modules/OrderSetup/Pages/OrderSetupEdit";
import { MarketSelectPage } from "Settings/Pages/MarketSelectPage";
import { VerticalSelectPage } from "Settings/Pages/VerticalSelectPage";
import { VerticalSetupPage } from "Settings/Pages/VerticalSetupPage";
import { SettingsPaths } from "Settings/Routes/Routing";
import { UsersPage } from "Settings/User/Pages";
import { EditUserPage } from "Settings/User/Pages/edit";
import { UserProfileTabs } from "Settings/User/Pages/hooks/useUserProfileTabs";
import { UserProfile } from "Settings/User/Pages/UserProfile";
import {
	UserRoles,
	UserRolesContentType,
} from "Settings/User/Pages/UserRoles/UserRoles";

export const SettingsRoutes = [
	{
		path: SettingsPaths.UsersIndex.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.UserModule.view}>
				<UsersPage />
			</PermissionGuard>
		),
	},
	{
		path: SettingsPaths.UsersEdit.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.UserModule.update}>
				<EditUserPage />
			</PermissionGuard>
		),
	},
	{
		path: SettingsPaths.UserDetail.route,
		exact: true,
		element: <UserProfile currentTab={UserProfileTabs.detail} />,
	},
	{
		path: SettingsPaths.UsersRoles.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.UserRolesModule.view}>
				<UserRoles currentContent={UserRolesContentType.Default} />
			</PermissionGuard>
		),
	},
	{
		path: SettingsPaths.UsersRolesEdit.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.UserRolesModule.update}>
				<UserRoles currentContent={UserRolesContentType.Edit} />
			</PermissionGuard>
		),
	},
	{
		path: SettingsPaths.UsersRolesAdd.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.UserRolesModule.create}>
				<UserRoles currentContent={UserRolesContentType.Add} />
			</PermissionGuard>
		),
	},
	{
		// TODO Refactor permissions
		path: SettingsPaths.VerticalSetupMarketSelect.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.OrderSetupModule.view}>
				<MarketSelectPage />
			</PermissionGuard>
		),
	},
	{
		path: SettingsPaths.VerticalSetupVerticalSelect.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.OrderSetupModule.view}>
				<VerticalSelectPage />
			</PermissionGuard>
		),
	},
	{
		path: SettingsPaths.VerticalSetupSelect.route,
		element: (
			<PermissionGuard permission={UserPermissions.OrderSetupModule.read}>
				<VerticalSetupPage />
			</PermissionGuard>
		),
		children: [
			{
				path: SettingsPaths.GeneralSetup.route,
				element: (
					<PermissionGuard
						permission={UserPermissions.VerticalGeneralSetupModule.update}
					>
						<GeneralSetupEditPage />
					</PermissionGuard>
				),
			},
			{
				path: SettingsPaths.OrderSetupEdit.route,
				element: (
					<PermissionGuard permission={UserPermissions.OrderSetupModule.update}>
						<OrderSetupEditPage />
					</PermissionGuard>
				),
			},
		],
	},
];
